declare namespace $ {

	type $mol_image__uri_shm_hitalama_vk_token_view_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_token_view['logo_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__uri_shm_hitalama_vk_token_view_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_token_view['avatar_url'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__title_shm_hitalama_vk_token_view_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_vk_token_view['user_id'] >
		,
		ReturnType< $mol_image['title'] >
	>
	export class $shm_hitalama_vk_token_view extends $mol_view {
		user_id( ): string
		logo_uri( ): string
		Logo( ): $mol_image
		avatar_url( ): string
		Avatar( ): $mol_image
		token( ): $shm_hitalama_vk_token
		title( ): ReturnType< $shm_hitalama_vk_token_view['user_id'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=view.view.tree.d.ts.map